import ApiService from "./ApiService";
import LocalStorageService from "./LocalStorageService";
import Logger from "./Logger";

class PubKeyManagerService{

    async loadPubKey(uid: string): Promise<string> {

        try {
            let pubKey = LocalStorageService.getPubKey(uid)
            if(pubKey)
             return pubKey
            else{
    
                let resp = await ApiService.getPubKey({matchUid: uid})
                LocalStorageService.updatePubKey(uid, resp.data.pubKey)
                return resp.data.pubKey
            }
        } catch (err) {
            Logger.err(err)
            throw 'Public Key not avail'
        }
    }

    removePubKey(uid: string){
        LocalStorageService.removePubKey(uid)
    }

    checkPubKey(uid: string){
        return LocalStorageService.getPubKey(uid)
    }

}

export default new PubKeyManagerService()